<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  mounted() {
    this.checkEdge()
  },
  data() {
    return {
    }
  },
  methods: {
    checkEdge() {
      if (navigator.userAgent.match('Edg/')) {
        this.setCssPadding()
      }
    },
    setCssPadding() {
      for (var si in document.styleSheets) {
        var styleSheet = document.styleSheets[si];
        if (!styleSheet.cssRules) continue;
        for (var ri = styleSheet.cssRules.length - 1; ri >= 0; ri--) {
          if (!styleSheet.cssRules[ri].selectorText) continue;
          if (
            styleSheet.cssRules[ri].cssText.match('--el-main-padding') &&
            styleSheet.cssRules[ri].selectorText.match('.el-main') &&
            !styleSheet.cssRules[ri].selectorText.match(':root') &&
            styleSheet.cssRules[ri].styleMap.size == 1
          ) {
            styleSheet.deleteRule(ri);
            styleSheet.insertRule(".el-main {--el-main-padding: 44px 30px 0 74px;}", styleSheet.cssRules.length)
          }
        }
      }
    },
  }
}
</script>

<style>
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.el-main {
  background: #FFFFFF;
}

.el-row {
  justify-content: center;
  padding-bottom: 2px;
}

.el-checkbox {
  --el-checkbox-border-radius: 50% !important;
  --el-checkbox-bg-color: #dadad8 !important;
  --el-checkbox-checked-input-border-color: #ffcc00 !important;
  --el-checkbox-checked-bg-color: #ffcc00 !important;
  --el-checkbox-input-height: 24px !important;
  --el-checkbox-input-width: 24px !important;
}

.el-checkbox.el-checkbox--large .el-checkbox__inner {
  width: 24px !important;
  height: 24px !important;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #383838 !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner::after {
  transform: rotate(45deg) scaleY(1) !important;
}

.el-checkbox__inner::after {
  box-sizing: content-box !important;
  content: "" !important;
  border: 3px solid var(--el-checkbox-checked-icon-color) !important;
  border-left: 0 !important;
  border-top: 0 !important;
  height: 13px !important;
  left: 7px !important;
  position: absolute !important;
  top: 1px !important;
  transform: rotate(45deg) scaleY(0) !important;
  width: 5px !important;
  transition: transform .15s ease-in 50ms !important;
  transform-origin: center !important;
}

.el-table th.el-table__cell {
  background: #EEEEEC !important;
  /* border-bottom:2px solid #C3C2C1!important; */
  /* border-bottom:2px solid #CDCCCA!important; */
}

.el-table {
  --el-table-border: 2px solid #FFFFFF !important;
  --el-table-row-hover-bg-color: initial !important;
  --el-table-border-color: initial !important;
  --el-table-header-text-color: #383838 !important;
}

.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background: #F8F8F7 !important;
}

.el-table__row:nth-child(even):not(:hover) .el-table__cell {
  border-bottom: solid 2px #F8F8F7;
}

.el-table__row:nth-child(odd):not(:hover) .el-table__cell {
  border-bottom: solid 2px white;
}

.el-table__row:hover td {
  border-top: solid 2px #FFDF5E !important;
  border-bottom: solid 2px #FFDF5E !important;
}

.el-table__row:hover td .cell {
  margin-top: -2px;
}

.el-table__row:hover td:first-child .cell {
  margin-left: -2px;
}

.el-table__row:hover td:first-child {
  border-left: solid 2px #FFDF5E !important;
}

.el-table__row:hover td:last-child {
  border-right: solid 2px #FFDF5E !important;
}

.el-date-table td.current:not(.disabled) .el-date-table-cell__text {
  color: initial !important;
  background-color: #FFDF5E !important;
}

.el-table .cell {
  padding: 0 !important;
}

.el-table__body-wrapper .el-table-column--selection>.cell,
.el-table__header-wrapper .el-table-column--selection>.cell {
  height: 24px !important;
}

.el-table__empty-block {
  display: none !important;
}

.el-select-v2__wrapper {
  height: 50px !important;
}

th {
  font-weight: normal !important;
}

.vc-highlight {
  background-color: #FFDF5E !important;
}

.vc-day-content {
  /* color: initial!important; */
  --white: #383838 !important;
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
}


/* .el-overlay {
  z-index: 2015 !important;
} */

.el-radio__input.is-checked .el-radio__inner {
  background: #FFDF5E !important;
  border-color: #FFDF5E !important;
}

.el-radio__inner {
  background: #DADAD8 !important;
  border-color: #DADAD8 !important;
}

.el-radio__input.is-checked+.el-radio__label {
  color: #606266 !important;
}

.el-radio {
  --el-radio-font-size: var(--el-font-size-base);
  --el-radio-text-color: var(--el-text-color-regular);
  --el-radio-font-weight: var(--el-font-weight-primary);
  --el-radio-input-height: 24px !important;
  --el-radio-input-width: 24px !important;
  --el-radio-input-border-radius: var(--el-border-radius-circle);
  --el-radio-input-bg-color: var(--el-fill-color-blank);
  --el-radio-input-border: var(--el-border);
  --el-radio-input-border-color: var(--el-border-color);
  --el-radio-input-border-color-hover: var(--el-color-primary);
}

.el-radio__inner::after {
  width: 10px !important;
  height: 10px !important;
  border-radius: var(--el-radio-input-border-radius);
  background-color: var(--el-color-white);
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform .15s ease-in;
}

.el-button {
  --el-button-disabled-text-color: #E8E2C6 !important;
  --el-button-hover-text-color: rgba(56, 56, 56, 0.6) !important;
}

.el-badge__content.is-dot {
  height: 10px !important;
  width: 10px !important;
}

.title-header {
  height: 60px;
  width: 100%;
  font-size: 18px;
}

.el-table__body,
.el-table__footer,
.el-table__header {
  height: 60px !important;
  font-size: 16px !important;
}

.el-switch__core .el-switch__inner .is-text {
  color: #383838 !important;
}

.el-message-box__content {
  white-space: pre-line !important;
}

.text-center {
  text-align: center;
}

.font_12 {
  font-size: 12px;
}

.font_14 {
  font-size: 14px;
}

.font_16 {
  font-size: 16px;
}

.font_18 {
  font-size: 18px;
}

.font_bold {
  font-weight: bold;
}

.width100 {
  width: 100%;
}
</style>
